import { $, $$, isScreenOrBellow, onReady } from "../libraries/utils"

onReady(function () {
    initProductsFilters()
})

// Home slider
function initProductsFilters() {
    const productsFiltersContainers = $$(".js-products-filter-form")
    if (!productsFiltersContainers.length) {
        return
    }

    registerPopstateListener()
    linkSortOrderToProductsFilters()

    productsFiltersContainers.forEach((block) => {
        block.addEventListener("change", filterProducts)
        block.addEventListener("submit", filterProducts)
    })
}

function registerPopstateListener() {
    window.addEventListener("popstate", function (event) {
        if (event.state?.xhrUrl && event.state?.searchQuery) {
            updateProductsList(event.state.xhrUrl, event.state.searchQuery)
        }

        if (event.state?.serializedData) {
            restoreFormsState(event.state.serializedData)
        }
    })
}

function linkSortOrderToProductsFilters() {
    $(".js-product-sort").addEventListener("change", (event) => {
        $$(".js-product-sort-target").forEach(function (input) {
            input.value = event.target.value
        })

        if (isScreenOrBellow("sm")) {
            $("#products-filters-modal").dispatchEvent(
                new CustomEvent("change")
            )
        } else {
            $("#products-filters").dispatchEvent(new CustomEvent("change"))
        }
    })
}

function filterProducts(event) {
    event.preventDefault()
    event.stopImmediatePropagation()

    const form = event.currentTarget
    const formData = new FormData(form)
    const searchQuery = new URLSearchParams(formData).toString()
    const serializedData = serializeFormData(formData)

    try {
        history.replaceState(
            {
                xhrUrl: form.action,
                searchQuery,
                serializedData,
            },
            "",
            document.location.pathname + "?" + searchQuery
        )
    } catch (error) {}

    updateProductsList(form.action, searchQuery)
}

function updateProductsList(xhrUrl, params) {
    const productsList = $("#product-list-result")
    productsList.classList.add("loading-overlay")

    axios
        .get(xhrUrl + "?" + params)
        .then((response) => {
            productsList.innerHTML = response.data.products

            let productsCountText = $(".js-products-list-count")
            if (response.data.productsCount !== 1) {
                productsCountText.innerText =
                    Benoit.productListL8n.article_count_plural.replace(
                        ":count",
                        response.data.productsCount
                    )
            } else {
                productsCountText.innerText =
                    Benoit.productListL8n.article_count_singular
            }
        })
        .catch((error) => {
            alert(
                "Une erreur est survenue pendant la récupération des produits."
            )
            console.error(error)
        })
        .finally(() => {
            productsList.classList.remove("loading-overlay")
        })
}

function restoreFormsState(serializedData) {
    $$('.js-products-filter-form input[type="checkbox"]').forEach(function (
        input
    ) {
        if (serializedData[input.name]) {
            input.checked = serializedData[input.name].includes(input.value)
        } else {
            input.checked = false
        }
    })
    $$(".js-product-sort").forEach(function (order) {
        if (serializedData[order.name]) {
            order.value = serializedData[order.name][0]
        }
    })
}

function serializeFormData(formData) {
    let serialized = {}
    for (let pair of formData.entries()) {
        if (!serialized[pair[0]]) {
            serialized[pair[0]] = []
        }

        serialized[pair[0]].push(pair[1])
    }
    return serialized
}
